<template>
  <div>
    school_statistics
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
</style>